/**
 * The auth operations, kept by hand.
 *
 * Every other operation is derived from introspection at runtime; these four
 * cannot be, because a caller needs them *before* it holds a token to introspect
 * with. `npm run codegen` types them against the supergraph.
 */
import { gql } from '../generated/gql.ts';

// ── Queries ──

export const LogoutUrl = gql(`
  query LogoutUrl {
    logoutUrl
  }
`);

// ── Mutations ──

export const DeviceAuthorize = gql(`
  mutation DeviceAuthorize($input: DeviceAuthorizeInput!) {
    deviceAuthorize(input: $input) {
      deviceCode
      expiresIn
      interval
      userCode
      verificationUri
      verificationUriComplete
    }
  }
`);

export const DeviceToken = gql(`
  mutation DeviceToken($input: DeviceTokenInput!) {
    deviceToken(input: $input) {
      accessToken
      error
      expiresIn
      idToken
      refreshToken
      tokenType
    }
  }
`);

export const RefreshToken = gql(`
  mutation RefreshToken($input: RefreshTokenInput!) {
    refreshToken(input: $input) {
      accessToken
      error
      expiresIn
      idToken
      refreshToken
      tokenType
    }
  }
`);
